import { observable } from 'mobx';
import { AppConstants, Types } from '../../../common/APIConstants';
import ReferenceDataAPI from '../../referencedata/services/reference-data-service';
import LeaseMasterChangeService from '../services/lease-master-changes-service';
import _ from 'lodash';
import moment from 'moment';

class LeaseMasterPriceChangeStore {
  @observable approveBtnText = 'Approve';
  @observable rejectBtnText = 'Reject';
  @observable exportBtnText = 'Export';
  @observable refreshBtnText = 'Refresh';
  @observable saveProfileText = 'Save Profile';
  @observable resetProfileText = 'Reset Profile';
  @observable rowData = [];
  @observable columnDefinitions = [];
  @observable rowDataFetched = false;
  @observable marketingRepList = [];


  getScreenData = async (userEmail,currentScreen, CommonStore) => {
    CommonStore.toggleLoader();
    this.hasScreenData = false;
    try {
      const requestObj = {
        "userEmail": userEmail,
        "screenName": currentScreen.screen.name
      };
      const { screen, screenColumns: columns } = currentScreen;
      this.columnDefinitions = this.getColumnDefinitions(screen, columns);
      this.rowDataFetched = true;
      await this.refreshScreenData(requestObj);
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      if (error.response && error.response.data.includes("Data not available")) {
        window.toastr.error(error.response.data);
      }
      else {
        window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
      }
    }
  };

  refreshScreenData = async (requestObj) => {
    const { data } = await LeaseMasterChangeService.GetPriceChanges(requestObj);
    this.rowData = data;
  }

  getMarketingRepList = async () => {
    try {
      const { data } = await LeaseMasterChangeService.GetMarketingRepList();
      this.marketingRepList = data;
    } catch (error) {
      if (error.response && error.response.data.includes("Data not available")) {
        window.toastr.error(error.response.data);
      }
      else {
        window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
      }
    }
  };

  addComment = async (id,comment,CommonStore,status,screenname)=>{
    let params = {};
    if(screenname=='SOXLeasePricing'){
      params = {
        "screen": {
          "title": "Lease Audit Pricing Changes",
          "name": "SOXLeasePricing",
          "tableName": "SOX.LeaseMasterData",
          "canAddRow": false,
          "canCopyRow": false,
          "canDeleteRow": false,
          "canEditRow": false,
          "active": true,
          "deleteType": "null",
          "duplicateCheckRequired": false,
          "columnsForDuplicate": "null",
          "isCustomScreen": true,
          "hasParent": false,
          "parent": "null",
          "navWrapper": "SOXAuditScreens",
          "partitionKey": "SOXLeasePricing",
          "rowKey": "SOXLeasePricing",
          "timestamp": moment().format('YYYY-MM-DD HH:mm:ss'),
          // "eTag": "W/\"datetime'"+moment().format('YYYY-MM-DD HH:mm:ss')+"'\""
        },
        "Id": id,
        "Comment": comment,
        "IsAdd": status?true:false
      }
    }else{
      params = {
        "screen": {
          "title": "Contract Audit Pricing Changes",
          "name": "SOXContractPricing",
          "tableName": "SOX.ContractMasterData",
          "canAddRow": false,
          "canCopyRow": false,
          "canDeleteRow": false,
          "canEditRow": false,
          "active": true,
          "deleteType": "null",
          "duplicateCheckRequired": false,
          "columnsForDuplicate": "null",
          "isCustomScreen": true,
          "hasParent": false,
          "parent": "null",
          "navWrapper": "SOXAuditScreens",
          "partitionKey": "SOXContractPricing",
          "rowKey": "SOXContractPricing",
          "timestamp": moment().format('YYYY-MM-DD HH:mm:ss'),
          // "eTag": "W/\"datetime'"+moment().format('YYYY-MM-DD HH:mm:ss')+"'\""
        },
        "Id": id,
        "Comment": comment,
        "IsAdd": status?true:false
      }
    }

    CommonStore.toggleLoader();
    try {
      let r = await ReferenceDataAPI.addComment(params);
      CommonStore.toggleLoader();
      return {status:r};
      //window.toastr.success(AppConstants.TOASTER_SUCCESS);
     
    }
    catch (error) {
      
      CommonStore.toggleLoader();
      return {status:false,message:error};
      //window.toastr.error(AppConstants.TOASTER_ERROR_SAVE_TEXT);
    }
  }

  saveScreenData = async (saveObj, CommonStore, currentScreen) => {
    CommonStore.toggleLoader();
    try {
      const addScreen = {};
      Object.assign(addScreen, currentScreen);
      addScreen.data = saveObj;
      await ReferenceDataAPI.updateData(addScreen);
      window.toastr.success(AppConstants.TOASTER_SUCCESS);
      CommonStore.toggleLoader();
    }
    catch (error) {
      CommonStore.toggleLoader();
      window.toastr.error(AppConstants.TOASTER_ERROR_SAVE_TEXT);
    }
  };


  getColumnDefinitions = (screen, columns) => {
    const gridColumns = [];
    const effectiveDateValueGetter = (params) => ( params.data ? "Effective Date: " + params.data.EffectiveDate:"" )
    const changeTextLineValueGetter = (params) => {
    if (params.data) {    
      var changeTextArr = [params.data.ChangeTextLine2,
                           params.data.ChangeTextLine3,
                           params.data.ChangeTextLine4,
                           params.data.ChangeTextLine5,
                           params.data.ChangeTextLine6,
                           params.data.ChangeTextLine7,
                           params.data.ChangeTextLine8,
                           params.data.ChangeTextLine9,
                           params.data.ChangeTextLineA];}
      const concatChangeText = () => {
        let s = params.data.ChangeTextLine1;
        changeTextArr.forEach(changeTextLine => {
          if(changeTextLine && changeTextLine.trim()!="") 
            s += " || " + changeTextLine;
          }  
        );
        return s; 
      }
      return params.data ? concatChangeText() : ""
    }
    const contractValueGetter = (params) => ( params.data ? ((params.data.Contract ? params.data.Contract.trim():"")=="" ? params.data.ContractName.trim() : params.data.ContractName.trim() + '-' + params.data.Contract):"" )
    const operatorValueGetter = (params) => ( params.data ? params.data.OperatorName + '-' + params.data.OperatorID : "")
    const deliveryRowGroupValueGetter = (params) => ( params.data ? ((params.data.Location ? params.data.Location.trim():"")!="" ? params.data.Location + " - " + params.data.LocationName + " - " +  params.data.BillingCode + " - " + params.data.CrudeGrade  :"N/A" ) : "");

    const ChangeTextLine9 = (params) => ( params.data ? params.data.OperatorName + '-' + params.data.OperatorID : "")
    

    const assignValueGetter = (columnName) => {
      switch(columnName){
        case 'ChangeTextLineGroup': return changeTextLineValueGetter;
        case 'EffectiveDate': return effectiveDateValueGetter;
        case 'OperatorName': return operatorValueGetter;
        //case 'ChangeTextLine1': return changeTextLineValueGetter;
        case 'ContractName': return contractValueGetter;
        case 'DeliveryRowGroup': return deliveryRowGroupValueGetter;
        
        default : return null;
      }
    }

    columns.forEach((column) => {
      gridColumns.push({
        field: column.name,
        headerName: column.title,
        type: 'text',
        hide: column.hidden,
        width: !column.name.includes('ChangeText') ? (column.width ? column.width : 200) : 600,
        rowGroup:column.rowGroup,
        valueGetter: assignValueGetter(column.name),
      });
    });
    return gridColumns;
  };
}

export default new LeaseMasterPriceChangeStore();